import React from 'react';
import { FaStar, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "./CustSaying.css";

import anas from "../../assets/image/anas.png";
import atheer from "../../assets/image/atheer.png";
import abdall1 from "../../assets/image/abdall.png";
import abdall2 from "../../assets/image/Abbdalla2.png";
import ruby from "../../assets/image/ruby.png";
import rahf from "../../assets/image/rafa.png";
import ahmed from "../../assets/image/ahmed.png";
import rian from "../../assets/image/rian.png";
import mahmoud from "../../assets/image/mohamed.png";
import merehan from "../../assets/image/mohamed.png";

export default function CustSaying() {

  const testimonials = [
    { id: 1, name: "Anas Naser", date: "2024-04-03", image: anas, comment: "مكتب يمتلك خبرة وموظفين أكفاء" },
    { id: 2, name: "Atheer", date: "2024-04-02", image: atheer, comment: "سلطان إنسان صبور وقدم لي المساعدة فوق الممتاز، شكراً سلطان من القلب ❤️" },
    { id: 3, name: "Abdullah Alkaabi", date: "2024-04-01", image: abdall1, comment: "تم الرد على جميع استفساراتي بسرعة وباحترافية." },
    { id: 4, name: "ABDULLAH DASHEL", date: "2024-03-27", image: abdall2, comment: "تم الرد على جميع اسفساراتي المتعلقه بالسفر والتاشيره بسرعه وباحترافيه." },
    { id: 5, name: "روابي الشمراني", date: "2024-03-24", image: ruby, comment: "من افضل المكاتب اللي تعاملت معاها" },
    { id: 6, name: "رهف محمد", date: "2024-04-03", image: rahf, comment: "كانت رائعه الموظف امجد ناصر ملم بكل شيء ومرتب كل حاجة" },
    { id: 7, name: "أحمد المرحبي", date: "2024-04-04", image: ahmed, comment: "شكرا لتعامل الجميل والاسلوب الراقي اشكر الموظف امجد ناصر عل حسن تعامله 🤍🤍🤍" },
    { id: 8, name: "ريان ناصر", date: "2024-04-09", image: rian, comment: "تعاملت مع الاخ فهد محمد انسان خلوق ومتفهم ويوضح لك كل النقاط والاسعار والسفرة من إلى ويساعدك بكل شي تحتاجه ويدور لك اقل العروض الله يعطيه العافيه" },
    { id: 9, name: "Mohammed Abdullah", date: "2024-04-13", image: mahmoud, comment: "الله يعطيكم العافيه صراحة شركة ممتازه و خصوصًا (أمجد ناصر ) متابع معايه من البدايه حتى النهاية ويوفر عروض ممتازه ، شكراً لكم وشكر كبير وخاص لأستاذ امجد الله يعطيه العافيه" },
    { id: 10, name: "Merehan Emad", date: "2024-04-13", image: merehan, comment: "اشكر اخوي امجد على اعداد البرنامج والتجاوب في التعديلات للوصول الى برنامج ممتع واختيار السكن من فنادق وكهف، بحول الله يكون لي نصيب بالسفر مع هذه الشركه" }
  ];

  const arrowStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 2,
    backgroundColor: '#bb2d3b',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#fff',
    boxShadow: '0 4px 12px rgba(3, 51, 42, 0.2)'
  };

  const NextArrow = ({ onClick }) => (
    <div onClick={onClick} style={{ ...arrowStyle, right: '-30px' }}>
      <FaChevronRight size={20} />
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div onClick={onClick} style={{ ...arrowStyle, left: '-30px' }}>
      <FaChevronLeft size={20} />
    </div>
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    rtl: true,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: "ease-in-out",
    pauseOnHover: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  };

  return (
    <section className="py-5 bg-light testimonials-section position-relative overflow-hidden" dir="rtl">
      <div className="container">
        <h2 className="text-center mb-5 fw-bold " style={{color:"#bb2d3b"}}>آراء العملاء</h2>
        <Slider {...settings}>
          {testimonials.map((t, idx) => (
            <div key={t.id} className="px-3 animate__animated animate__fadeInUp" style={{ animationDelay: `${idx * 0.2}s` }}>
              <div className="testimonial-card text-center p-4">
                <div className="avatar-wrapper mx-auto mb-3">
                  <img src={t.image} className="avatar-img" alt={t.name} />
                  <FcGoogle className="google-icon" />
                </div>
                <h5 className="fw-bold text-dark mb-0">{t.name}</h5>
                <small className="text-muted">{t.date}</small>
                <div className="stars my-2">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} className="text-warning mx-1" size={18} />
                  ))}
                </div>
                <p className="testimonial-comment position-relative text-muted small">
                  <span className="quote-mark">“</span>
                  {t.comment.length > 100 ? t.comment.substring(0, 100) + "..." : t.comment}
                  <span className="quote-mark end">”</span>
                </p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}